import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Materia } from '../models/materia';

@Injectable({
  providedIn: 'root'
})
export class MateriaService {
  constructor(private globalService: GlobalService, private http: HttpClient) { }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
    thumb
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '')
      .set('thumb', thumb.toString());

    return this.http.get<any>(globals.apiUrl + '/api/Materia/ListaPag', {
      params: parametros,
    });
  }

  consultarMaterias() {
    return this.http.get<Materia[]>(globals.apiUrl + '/api/Materia/Lista');
  }

  consultarNoticiasEconomia() {
    return this.http.get<Materia[]>(globals.apiUrl + '/api/Materia/ListaThumb');
  }

  consultarMateriasDashboard() {
    return this.http.get<Materia[]>(globals.apiUrl + '/api/Materia/ListarDashboard');
  }

  consultarPorId(idMateria) {
    let parametros = new HttpParams().set('id', idMateria);

    return this.http.get<any>(globals.apiUrl + '/api/Materia/Buscar', {
      params: parametros,
    });
  }

  consultarImagemThumbPorId(idMateria) {
    return this.http.get(globals.apiUrl + '/api/Materia/BuscarImagem',
      { params: new HttpParams().set('id', idMateria).set('thumb', 'true'), responseType: 'blob' });
  }

  consultarImagemPorId(idMateria) {
    return this.http.get(globals.apiUrl + '/api/Materia/BuscarImagem',
      { params: new HttpParams().set('id', idMateria).set('thumb', 'false'), responseType: 'blob' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Materia/Excluir', {
      params: new HttpParams().set('id', id),
    });
  }

  salvar(materia) {
    return this.http.post(globals.apiUrl + '/api/Materia/Salvar', materia);
  }
}
